import store from '@/store/'
// eslint-disable-next-line no-unused-vars
export default function suspended({ from, next, router, to }) {
  // console.log('middleware/auth | from', from)
  // console.log('middleware/auth | to', to)

  // redirect to login if unauthenticated
  if (!store.getters['auth/is_auth']) {
    // localStorage.setItem(keys.LAST_USER, JSON.stringify(store.state.user.data.id))
    store.dispatch('CANCEL_PENDING_REQUESTS')
    if (router.currentRoute.name !== 'login') {
      return router.push({ name: 'login' })
    } else {
      return
    }
  } else if (!store.getters['auth/is_suspended']) {
    return router.push({ name: 'dashboard' })
  }

  // OR do nothing and go next
  return next()
}
